var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.928,
    height: 18.928,
    viewBox: "0 0 18.928 18.928",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "facebook-logo-2019",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9520",
    "data-name": "Path 9520",
    d: "M18.928,9.464A9.464,9.464,0,1,0,7.985,18.813V12.2h-2.4V9.464h2.4V7.379A3.34,3.34,0,0,1,11.56,3.7a14.553,14.553,0,0,1,2.118.185V6.211H12.485a1.368,1.368,0,0,0-1.542,1.478V9.464h2.625l-.42,2.736H10.943v6.613A9.466,9.466,0,0,0,18.928,9.464Z",
    transform: "translate(0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9521",
    "data-name": "Path 9521",
    d: "M309.566,208.5l.42-2.736H307.36v-1.775a1.368,1.368,0,0,1,1.542-1.478H310.1v-2.329a14.554,14.554,0,0,0-2.118-.185,3.34,3.34,0,0,0-3.575,3.682v2.085H302V208.5h2.4v6.613a9.564,9.564,0,0,0,2.957,0V208.5Z",
    transform: "translate(-296.418 -196.303)",
    fill: "#5d8c4a"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.64cbfde4b04aab47ac9f0c186fe465ba.svg";
export { ForwardRef as ReactComponent };